module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Lily-meisje-letterpress-roze-debossing-digitaal-drukwerk-3.8a19b860.jpg";